<template>
  <div class="bl-tooltip-component">
    <slot></slot>
    <div
      v-if="$slots.tooltip || tooltip"
      class="bl-tooltip"
      :class="[`bl-tooltip-drop-${drop}`]"
    >
      <div
        v-if="$slots.tooltip"
        class="text-xs font-normal leading-relaxed tracking-wide text-center text-pure-white"
      >
        <slot name="tooltip"></slot>
      </div>
      <BlTextBody3 v-if="tooltip" class="bl-tooltip-text" :text="tooltip" />
    </div>
  </div>
</template>

<script>
import BlTextBody3 from "./BlTextBody3.vue";
export default {
  name: "BlTooltip",
  components: { BlTextBody3 },
  props: {
    tooltip: { type: String, default: "" },
    drop: { type: String, default: "down" }
  }
};
</script>

<style scoped lang="scss">
.bl-tooltip-component {
  position: relative;
  display: flex;
  .bl-tooltip {
    pointer-events: none;
    opacity: 0;
    position: absolute;
    min-width: 100%;
    max-width: 24rem;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    background: var(--Dark-Purple-2, #45356d);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    .bl-tooltip-text {
      color: #fff;
      text-align: center;
    }
    &::before {
      content: "";
      position: absolute;
      margin-left: -0.5rem;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent transparent var(--Dark-Purple-2, #45356d)
        transparent;
    }
  }
  .bl-tooltip-drop-down {
    top: calc(100% + 0.5rem);
    left: 50%;
    transform: translateX(-50%);
    &::before {
      bottom: 100%;
      left: 50%;
    }
  }
  .bl-tooltip-drop-right {
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    &::before {
      right: 100%;
      transform: rotate(-90deg);
    }
  }
  .bl-tooltip-drop-top {
    bottom: calc(100% + 0.5rem);
    left: 50%;
    transform: translateX(-50%);
    &::before {
      top: 100%;
      left: 50%;
      transform: rotate(180deg);
    }
  }
  &:hover {
    .bl-tooltip {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlTooltip.vue